module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/chart/storage/storage.component.css
// module id = ./src/app/chart/storage/storage.component.css
// module chunks = main